<div class="wrapper-modal">
  <form [formGroup]="refundGiftsForm" (ngSubmit)="submitEditUserForm()" class="wrapper-content-modal">
    <div class="header-modal">
      <span class="title-modal">Refindacija za selektovane poklone</span>
    </div>
    <div class="content-modal">
      <div class="xs-mb-20">
        <div class="wrapper-custom-radiobutton">
          <label>
            <input type="radio" formControlName="refund_type" [value]="'person'">
            <div class="custom-radiobutton">
              <div class="circle-radio">
                <div class="circle-center"></div>
              </div>
              <span>Fizićko lice</span>
            </div>
          </label>
          <label>
            <input type="radio" formControlName="refund_type" [value]="'company'">
            <div class="custom-radiobutton">
              <div class="circle-radio">
                <div class="circle-center"></div>
              </div>
              <span>Pravno lice</span>
            </div>
          </label>
        </div>
      </div>
      <div *ngIf="refundGiftsForm.controls.refund_type.value === 'person'" class="wrapper-input">
        <span class="label-input">JMBG</span>
        <div class="zc-input">
          <input type="text" [formControl]="refundGiftsForm.controls.buyer_id | formControl" [placeholder]="'JMBG'">
        </div>
        <span class="error-message">{{refundGiftsForm.controls.buyer_id | formControlErrorMessages: 'Unesite validan JMBG.' : formTriedToSubmit}}</span>
      </div>
      <div *ngIf="refundGiftsForm.controls.refund_type.value === 'company'" class="wrapper-input">
        <span class="label-input">PIB</span>
        <div class="zc-input">
          <input type="text" [formControl]="refundGiftsForm.controls.buyer_id | formControl" [placeholder]="'PIB'">
        </div>
        <span class="error-message">{{refundGiftsForm.controls.buyer_id | formControlErrorMessages: 'Unesite validan PIB.' : formTriedToSubmit}}</span>
      </div>
    </div>
    <div class="footer-modal">
      <button type="button" (click)="closeModal.emit()" class="zc-btn zc-btn--gray"><span>Izađi</span></button>
      <button type="submit" class="zc-btn zc-btn--primary"><span>Potvrdi</span></button>
    </div>
  </form>
</div>

<p>refund-presents-modal works!</p>
